import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Users, TrendingUp, Inbox, Clock, Euro, Eye, Target } from "lucide-react";

export default function AdminDashboard() {
  const [stats, setStats] = useState(null);
  useEffect(() => { (async () => setStats((await api.get("/admin/stats")).data))(); }, []);

  if (!stats) return <div className="text-muted-foreground">Chargement…</div>;

  const cards = [
    { label: "Partenaires actifs", value: stats.active_partners, icon: Users, hint: `${stats.total_partners} au total` },
    { label: "Valeur mensuelle cumulée", value: `${stats.monthly_cumulative_value}€`, icon: Euro, hint: "Réseau global / mois" },
    { label: "Soumissions à valider", value: stats.pending_submissions, icon: Inbox, hint: "Formulaire partenaire" },
    { label: "Offres expirent bientôt", value: stats.expiring_soon?.length || 0, icon: Clock, hint: "Dans les 30 jours" },
    { label: "Vues totales (offres)", value: stats.total_views || 0, icon: Eye, hint: "Ouvertures de fiches" },
    { label: "Intents 'Je profite'", value: stats.total_redeems || 0, icon: Target, hint: "Clics CTA offre" },
  ];

  return (
    <div className="space-y-8" data-testid="admin-dashboard">
      <div>
        <div className="text-xs uppercase tracking-widest text-navy-900/60 font-semibold">Tableau de bord</div>
        <h1 className="font-heading font-extrabold text-4xl text-navy-900 tracking-tighter mt-1">Pilotage du réseau</h1>
      </div>
      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {cards.map((c, i) => {
          const Icon = c.icon;
          return (
            <div key={i} className="card-premium p-6">
              <div className="flex items-start justify-between mb-3">
                <div className="w-10 h-10 rounded-xl bg-lime-500/15 flex items-center justify-center">
                  <Icon className="w-5 h-5 text-navy-900" />
                </div>
                <TrendingUp className="w-4 h-4 text-lime-600/60" />
              </div>
              <div className="font-heading font-extrabold text-3xl text-navy-900">{c.value}</div>
              <div className="text-sm text-muted-foreground mt-1">{c.label}</div>
              <div className="text-xs text-muted-foreground/80 mt-2">{c.hint}</div>
            </div>
          );
        })}
      </div>

      <div className="card-premium p-6 md:p-8">
        <h2 className="font-heading font-bold text-xl text-navy-900 mb-4">Offres expirant sous 30 jours</h2>
        {stats.expiring_soon?.length ? (
          <ul className="divide-y divide-navy-900/5">
            {stats.expiring_soon.map((p) => (
              <li key={p.id} className="py-3 flex items-center justify-between">
                <span className="font-medium text-navy-900">{p.name}</span>
                <span className="text-sm text-muted-foreground">{p.end_date}</span>
              </li>
            ))}
          </ul>
        ) : (
          <p className="text-muted-foreground text-sm">Aucune offre n'expire prochainement.</p>
        )}
      </div>
    </div>
  );
}
